export const rem = (px: number) => `${px / 16}rem`;
